import account from './account.json';
import addressForm from './addressForm.json';
import auth from './auth.json';
import billingHistory from './billingHistory.json';
import catGrass from './catGrass.json';
import common from './common.json';
import components from './components.json';
import deliveryActivity from './deliveryActivity.json';
import deliveryPage from './deliveryPage.json';
import flowers from './flowers.json';
import fruits from './fruits.json';
import forgotPassword from './forgotPassword.json';
import giftSubscription from './giftSubscription.json';
import login from './login.json';
import map from './map.json';
import navigation from './navigation.json';
import pages from './pages.json';
import payment from './payment.json';
import paymentRedirect from './paymentRedirect.json';
import paymentSuccess from './paymentSuccess.json';
import phoneVerify from './phoneVerify.json';
import refund from './refund.json';
import refundHistory from './refundHistory.json';
import register from './register.json';
import resetPassword from './resetPassword.json';
import rewardSuccess from './rewardSuccess.json';
import specialReward from './specialReward.json';
import stripePayment from './stripePayment.json';
import subscription from './subscription.json';
import subscriptionsList from './subscriptionsList.json';
import tipDriver from './tipDriver.json';
import upcomingServices from './upcomingServices.json';
import upgradeConfirmation from './upgradeConfirmation.json';
import verifyEmail from './verifyEmail.json';
import versionCheck from './versionCheck.json';
import welcome from './welcome.json';

export default {
  account,
  addressForm,
  auth,
  billingHistory,
  catGrass,
  common,
  components,
  deliveryActivity,
  deliveryPage,
  flowers,
  fruits,
  forgotPassword,
  giftSubscription,
  login,
  map,
  navigation,
  pages,
  payment,
  paymentRedirect,
  paymentSuccess,
  phoneVerify,
  refund,
  refundHistory,
  register,
  resetPassword,
  rewardSuccess,
  specialReward,
  stripePayment,
  subscription,
  subscriptionsList,
  tipDriver,
  upcomingServices,
  upgradeConfirmation,
  verifyEmail,
  versionCheck,
  welcome,
};